import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    CloneButton,
    ExportButton,
    TextField,
    ReferenceField,
    ReferenceInput,
    TextInput,
    EmailField,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
} from "react-admin"
import * as buttons from "components/ui/buttons"


const getCompanyFilters = (permissions: string): React.ReactElement[] => {
    const filters = [
        <TextInput source="name" />,
        <TextInput source="short_name" />,
        <ReferenceInput source="type_id" reference="company-types" />,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)
const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)


const CompanyList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            filters={getCompanyFilters(permissions)}
            //filterDefaultValues={{ role: "Company" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <ReferenceField label={translate("resources.companies.fields.name")} source="id" reference="companies">
                    <TextField source="name" label={translate("resources.companies.fields.name")} />
                </ReferenceField>
                <TextField source="short_name" label={translate("resources.companies.fields.short_name")} />
                <ReferenceField label={translate("resources.companies.fields.type_id")} source="type_id" reference="company-types">
                    <TextField source="name" />
                </ReferenceField>
                <EmailField source="email" label={translate("resources.companies.fields.email")} />
                <EmailField source="timezone" label={translate("resources.companies.fields.timezone")} />
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")}></DateField>
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <CloneButton label="" title={translate("ra.action.clone")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}

export default CompanyList